import { contactFormStyles as styles } from "@iewc/Overrides/Widgets/ContactUs/ContactForm";
import { css } from "styled-components";

styles.formGridItem = {
    ...styles.formGridItem,
    css: css`
        ${styles.formGridItem?.css}

        .contact-form__wrapper {
            width: 100%;
        }
    `,
};

styles.submitButton = {
    ...styles.submitButton,
    css: css`
        ${styles.submitButton?.css}
        float: none;
    `,
};

/* Verndale Custom Feature - New styles */
styles.reCaptchaWrapper = {
    css: css`
        margin-top: 20px;
    `,
};
